
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ApplicantSelectionHeader extends Vue {
    @Prop({ default: 'applicantChoose.title' }) titleKey!: string;
    @Prop({
        default: 'applicantChoose.descriptions'
    }) descriptionKey!: string;

    get descriptions (): Array<string> {
        const translation = this.$t(this.descriptionKey)
        return (Array.isArray(translation)
            ? translation
            : [
                translation
            ]) as Array<string>
    }
}
